import React, { useState, useEffect, useContext } from 'react';
import DashboardCard from './DashboardCard';
import FrequencyDashboardCard from './FrequencyDashboardCard';
import StatusChart from './StatusChart';
import ActivityLog from './ActivityLog';
import './Dashboard.css';
import { getDataForDashboard, getFrecuencia, updateFrecuencia } from '../../../Service/dashboardService';
import { getAppVersion } from '../../../Config.js';
import { AuthContext } from '../../../Context/AuthContext';
import { Typography } from '@mui/material';

const getTime = () => { 
  const today = new Date();
  return today.toLocaleString('es-ES', { hour12: false });
};

const Dashboard = () => {
  const [dataForDashboard, setDataForDashboard] = useState(null);
  const [time, setTime] = useState(getTime());
  const [appVersion, setAppVersion] = useState('Cargando...');
  const [frequency, setFrequency] = useState(3); // en minutos, default 3 minutos
  const { tokenExpiration, getAccessToken } = useContext(AuthContext);      

  useEffect(() => {
    const fetchVersion = async () => {
      const version = await getAppVersion();
      setAppVersion(version);
    };
    fetchVersion();
  }, []);

  useEffect(() => {
    const fetchFrequency = async () => {
      try {
        const token = await getAccessToken();
        const response = await getFrecuencia(token);
    
        console.log("Respuesta de getFrecuencia:", response);
    
        if (Array.isArray(response) && response.length > 0) {
          const frequencyFromDatabase = response[0].Frecuencia;
          console.log("Frecuencia obtenida:", frequencyFromDatabase);
    
          if (typeof frequencyFromDatabase === 'number' && frequencyFromDatabase > 0) {
            setFrequency(frequencyFromDatabase);
          }
        }
      } catch (error) {
        console.error("Error al obtener la frecuencia de actualización:", error);
      }
    };
    
    fetchFrequency();
  }, []);

  const fetchData = async () => {
    try {
      const token = await getAccessToken();
      const data = await getDataForDashboard(token);

      setDataForDashboard(data);
      setTime(getTime());
    } catch (error) {
      console.error("Error al obtener los datos del dashboard:", error);
    }
  };
  

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, frequency * 60000);
  
    return () => clearInterval(interval); // Limpieza del intervalo
  }, [frequency]);
  
  
  const handleUpdateFrequency = async (newFrequency) => {
     
     try {     
      const token = await getAccessToken();
      const result = await updateFrecuencia(newFrequency, token);
      
      if (result.success) {
        setFrequency(newFrequency);

      } else {
        //alert("Error al actualizar la frecuencia: " + result.message);
        console.error("Error al actualizar la frecuencia:", result.message);
      }
    } catch (error) {      
      //alert("Error en handleUpdateFrequency: " + error);
      console.error("Error en handleUpdateFrequency:", error);
    }
  };

  if (!dataForDashboard) {
    return <p>Cargando datos...</p>;
  }

  return (
    <div className='main-container'>
      <div className="dashboard-container">
        {/* Encabezado */}
        <Typography sx={{ fontSize: 14, color: 'gray', textAlign: 'left', width: '100%' }}>TABLERO DE SALUD DE SERVICIOS</Typography>
        {/* Tablero de Salud de Servicios */}
        {/* Panel con tarjetas y gráfico */}
          <div className="dashboard-panel">
            <div className="dashboard-cards">
              <DashboardCard title="Total de Servicios" value={dataForDashboard.spTablero_GetTotalDeServicios_Result[0]?.CantServicios ?? 0} />
              <DashboardCard title="Versión" value={appVersion} />
              <DashboardCard title="Última actualización" value={time} />

              <FrequencyDashboardCard
              title="Frecuencia de actualización (en minutos)"
              value={frequency}
              onUpdate={handleUpdateFrequency} 
            />

          </div>
    
          <div className="dashboard-chart">
          {dataForDashboard && <StatusChart data={dataForDashboard} />}
      </div>
    </div>
      {/* Tabla de registros */}
      <div className="dashboard-table">
        <ActivityLog data={dataForDashboard} />
      </div>
    </div>
    </div>
  );
  
  
};

export default Dashboard;